import { lazy } from "react";

export const VisitPaymentAsync = lazy(() => import("./VisitPayment"));
